function trimSlashes(str) {
    return str.replace(/^\/|\/$/g, '');
}
function startsWith(a, b) {
    return a.substr(0, b.length) == b;
}
export var action = Object.assign(function (data, cb, replace) {
    if (cb === void 0) { cb = null; }
    if (replace === void 0) { replace = false; }
    if (typeof data == 'string')
        return action({ url: data }, cb, replace);
    if (!data || !data.url)
        return {};
    var url = data.url, target = data.target;
    if (url.indexOf('mailto:') === 0)
        return { href: url };
    if (url.indexOf('@') > -1)
        return { href: 'mailto:' + url };
    if (url.indexOf('.') > -1 || url.indexOf('://') > -1)
        return {
            href: url,
            target: target || '_blank',
            rel: 'external noopener',
            onclick: cb
        };
    else
        return {
            href: url,
            target: target,
            onclick: function (e) {
                if (cb)
                    cb();
                action.anchorClick(e, url, replace);
            }
        };
}, {
    isActive: function (data, exact) {
        if (exact === void 0) { exact = false; }
        if (typeof data == 'string')
            return action.isActive({ url: data }, exact);
        var pathname = window.location.pathname;
        var path = trimSlashes(pathname);
        var url = trimSlashes(data.url);
        if (exact)
            return path == url;
        return startsWith(path, url);
    },
    anchorClick: function (e, href, replace) {
        if (replace === void 0) { replace = false; }
        if (e.which == 2)
            return;
        e.preventDefault();
        action.navigate(href, replace);
    },
    navigate: function (url, replace) {
        if (replace === void 0) { replace = false; }
        if (!url)
            return;
        if (typeof url != 'string' && 'url' in url)
            return action.navigate(url.url, replace);
        if (replace)
            history.replaceState(null, '', url);
        else
            history.pushState(null, '', url);
        window.onpopstate && window.onpopstate({ state: null });
    }
});
